module.exports = __webpack_public_path__ + "static/media/sutherland-self-help.80cba250.jpg";